import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useRenderLottieStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  })
);
